import { useState } from "react";
import { useTranslator } from "../../context/translator";

const ContractTap = ({
  tapSelected,
  handleChangeTap,
  clientId,
  contractId,
  handleBackCustomer,
}) => {
  const [css] = useState({
    selected:
      "inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group",
    unSelected:
      "inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group",
  });
  const { translate } = useTranslator();
  return (
    <>
      <div className="border-b border-gray-200 dark:border-gray-700 mb-2 flex items-center justify-between">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-gray-500 dark:text-gray-400">
          <li className="me-2">
            <button
              className={`${tapSelected === 1 ? css.selected : css.unSelected}`}
              onClick={() => handleChangeTap(1)}
            >
              <svg
                className="w-4 h-4 me-2 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
              </svg>
              {translate("contract")}
            </button>
          </li>

          <li className="me-2">
            <button
              className={`${tapSelected === 2 ? css.selected : css.unSelected}`}
              onClick={() => handleChangeTap(2)}
              disabled={contractId === "new" || clientId === "new"}
            >
              <svg
                className="w-4 h-4 me-2 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 18 20"
              >
                <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" />
              </svg>
              {translate("files")}
            </button>
          </li>
        </ul>
        <button
          onClick={handleBackCustomer}
          className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700"
        >
          {translate("back")} →
        </button>
      </div>
    </>
  );
};

export default ContractTap;
